import React from 'react';

export default function Instagram() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.755 8.188a4.623 4.623 0 1 0-.006 9.248 4.623 4.623 0 0 0 .006-9.248m-.005 7.627a3.004 3.004 0 1 1 .004-6.008 3.004 3.004 0 0 1-.004 6.008M17.561 9.1a1.078 1.078 0 1 0 .002-2.156A1.078 1.078 0 0 0 17.56 9.1'
        fill='currentColor'
      />
      <path
        d='M21.29 6.928a4.6 4.6 0 0 0-2.632-2.634 6.6 6.6 0 0 0-2.185-.421c-.963-.043-1.268-.055-3.71-.057s-2.755-.002-3.71.052a6.6 6.6 0 0 0-2.185.418 4.6 4.6 0 0 0-2.634 2.63 6.6 6.6 0 0 0-.42 2.186c-.044.962-.058 1.267-.06 3.71 0 2.442-.001 2.753.054 3.71.015.748.155 1.486.418 2.187a4.6 4.6 0 0 0 2.632 2.634 6.6 6.6 0 0 0 2.185.452c.963.042 1.268.055 3.71.057s2.755.002 3.71-.052a6.6 6.6 0 0 0 2.186-.418 4.6 4.6 0 0 0 2.635-2.631c.263-.7.405-1.438.42-2.186.044-.962.057-1.267.059-3.71s.002-2.753-.054-3.71a6.6 6.6 0 0 0-.42-2.217m-1.225 9.531a5 5 0 0 1-.312 1.688 3 3 0 0 1-1.713 1.71c-.535.198-1.1.302-1.67.31-.95.043-1.218.054-3.654.052-2.438-.002-2.687-.002-3.655-.057a5 5 0 0 1-1.669-.312 3 3 0 0 1-1.718-1.713 5.1 5.1 0 0 1-.31-1.669c-.042-.95-.052-1.218-.05-3.654s.002-2.686.055-3.655a5 5 0 0 1 .312-1.687 3 3 0 0 1 1.72-1.71 5 5 0 0 1 1.67-.31c.95-.043 1.218-.055 3.655-.053s2.687.002 3.654.058a5 5 0 0 1 1.67.312 3 3 0 0 1 1.71 1.713c.196.534.302 1.099.31 1.669.043.951.053 1.218.052 3.655s-.002 2.698-.046 3.654h-.01z'
        fill='currentColor'
      />
    </svg>
  );
}
